import React, { useState, useEffect } from 'react';
import { Layout, List, Menu, Avatar, Drawer, Divider, Button } from 'antd';
import { UserOutlined, HomeOutlined, MenuOutlined, ShopOutlined, BorderOuterOutlined, MailOutlined, LockOutlined, RightOutlined, MenuFoldOutlined } from '@ant-design/icons';
import ChangePasswordModal from '../modal/ChangePasswordModal.jsx';
import { useNavigate, useLocation  } from 'react-router-dom';
import './appHeader.scss';
const { Header } = Layout;

const AppHeader = ({email, cusId}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [passwordModalVisible, setPasswordModalVisible] = useState(false);
  const [menuDrawerVisible, setMenuDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const showPasswordModal = () => {
    setPasswordModalVisible(true);
    setDrawerVisible(false); // 关闭 Drawer，当显示密码模态框时
  };
  const handleLogout = () => {
    sessionStorage.removeItem('jwtToken');
   
    navigate('/qr_order/adminLogin');
  };
  const goToAdminList = () => {
    navigate('/qr_order/adminOrderList'); 
  };
  const goToMenuList = () => {
    
    navigate('/qr_order/adminMenuList'); 
  };
  const goToStoreConfig = () => {
    
    navigate('/qr_order/adminStoreConfig'); 
  };
  const goToTableSetup = () => {
    navigate('/qr_order/adminTableSetup');
  };
  const goToMenuGroupSetup = () => {
    navigate('/qr_order/adminMenuGroup');
  };
  const getDefaultSelectedKeys = () => {
    if (location.pathname.includes('/adminOrderList')) {
      return ['home'];
    } else if (location.pathname.includes('/adminMenuList')) {
      return ['menu'];
    }
    else if (location.pathname.includes('/adminTableSetup')) {
      return ['tableSetup'];
    }
    else if (location.pathname.includes('/adminStoreConfig')) {
      return ['storeConfig'];
    }
    else if (location.pathname.includes('/adminMenuGroup')) {
      return ['menuGroup'];
    }
    
    // 可以根据需要添加更多条件
    return []; // 如果没有匹配的路由，不选中任何项
  };

  const drawerContent = (
    <>
      <List>
        <List.Item>
          <List.Item.Meta
            avatar={<Avatar icon={<MailOutlined />} />}
            title="Email"
            description={email}
          />
        </List.Item>
        <List.Item onClick={showPasswordModal} style={{ cursor: 'pointer' }}>
          <List.Item.Meta
            avatar={<Avatar icon={<LockOutlined />} />}
            title="Password"
            description="********" // 替换为密码的占位符
          />
          <RightOutlined />
        </List.Item>
      </List>
      <Divider />
      <Button block type="primary" onClick={handleLogout}>Logout</Button>
    </>
  );

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onClose = () => {
    setDrawerVisible(false);
  };

  const showMenuDrawer = () => {
    setMenuDrawerVisible(true);
  };

  const closeMenuDrawer = () => {
    setMenuDrawerVisible(false);
  };

  const handleMenuClick = (action) => {
    action();
    closeMenuDrawer();
  };

  const menuItems = [
    { key: 'home', icon: <HomeOutlined />, label: 'Order List', onClick: goToAdminList },
    { key: 'menu', icon: <MenuOutlined />, label: 'Menu List', onClick: goToMenuList },
    { key: 'tableSetup', icon: <BorderOuterOutlined />, label: 'Table Setup', onClick: goToTableSetup },
    { key: 'storeConfig', icon: <ShopOutlined />, label: 'Store Setup', onClick: goToStoreConfig },
    { key: 'menuGroup', icon: <ShopOutlined />, label: 'Menu Group Setup', onClick: goToMenuGroupSetup },
  ];

  return (
    <>
      <Header style={{ position: 'fixed', zIndex: 1, width: '100%', padding: isMobile ? '0 16px' : '0 50px' }}>
        {isMobile ? (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '64px' }}>
            <Button 
              type="text" 
              icon={<MenuFoldOutlined style={{ fontSize: '20px', color: 'white' }} />} 
              onClick={showMenuDrawer}
            />
            <div style={{ fontSize: '18px', color: 'white', fontWeight: 'bold' }}>Admin Panel</div>
            <Avatar 
              style={{ backgroundColor: '#87d068', cursor: 'pointer' }} 
              icon={<UserOutlined />} 
              onClick={showDrawer}
            />
          </div>
        ) : (
          <Menu theme="dark" mode="horizontal" defaultSelectedKeys={getDefaultSelectedKeys()}>
            <Menu.Item key="home" icon={<HomeOutlined />} onClick={goToAdminList}>
              Order List
            </Menu.Item>
            <Menu.Item key="menu" icon={<MenuOutlined />} onClick={goToMenuList}>
              Menu List
            </Menu.Item>
            <Menu.Item key="tableSetup" icon={<BorderOuterOutlined />} onClick={goToTableSetup}>
              Table Setup
            </Menu.Item>
            <Menu.Item key="storeConfig" icon={<ShopOutlined />} onClick={goToStoreConfig}>
              Store Setup
            </Menu.Item>
            <Menu.Item key="menuGroup" icon={<ShopOutlined />} onClick={goToMenuGroupSetup}>
              Menu Group Setup
            </Menu.Item>
            <Menu.Item key="user" className="profile-menu-item" style={{ marginLeft: 'auto' }} onClick={showDrawer}>
              <Avatar style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />
            </Menu.Item>
          </Menu>
        )}
      </Header>
      
      <Drawer
        title="Navigation Menu"
        placement="left"
        closable={true}
        onClose={closeMenuDrawer}
        open={menuDrawerVisible}
        width={280}
      >
        <Menu
          mode="vertical"
          selectedKeys={getDefaultSelectedKeys()}
          style={{ border: 'none' }}
        >
          {menuItems.map(item => (
            <Menu.Item 
              key={item.key} 
              icon={item.icon}
              onClick={() => handleMenuClick(item.onClick)}
            >
              {item.label}
            </Menu.Item>
          ))}
        </Menu>
      </Drawer>
      <Drawer
        title="User Profile"
        placement="right"
        closable={true}
        onClose={onClose}
        open={drawerVisible}
      >
        {drawerContent}
        {/* 在这里添加 Drawer 的内容 */}
      </Drawer>
      <ChangePasswordModal cusId={cusId}
      visible={passwordModalVisible}
      setVisible={setPasswordModalVisible}
    />
    </>
  );
};

export default AppHeader;
